/**
 * Энергия года (core-loop-v2 §3): точки по одной на очко базы, лежащие
 * закрашены чернилами, потраченные — пустые; подпись «энергия 2 из 3».
 * Тап по полоске (кнопка ≥ 44px) раскрывает, почему очков меньше базы
 * (здоровье, возраст, школа, маленький ребёнок, хроническая болезнь).
 * Без цвета-оценки: точки — факт, а не похвала.
 */
import type { Life } from '@life/engine';
import { t } from '@life/i18n';
import type { JSX } from 'preact';
import { useState } from 'preact/hooks';
import { ENERGY_MAX, energyReasons } from '../state/turn';

export function EnergyBar({ life }: { life: Life }) {
  const [open, setOpen] = useState(false);
  const n = Math.max(0, Math.min(ENERGY_MAX, Math.trunc(life.energy)));
  const reasons = energyReasons(life);
  const dots: JSX.Element[] = [];
  for (let i = 0; i < ENERGY_MAX; i++) dots.push(<i key={i} class={i < n ? 'lit' : ''} />);
  return (
    <div class="energy-block">
      <button
        type="button"
        class="energy"
        aria-expanded={open}
        aria-label={t('ui.energy.label', { n, max: ENERGY_MAX })}
        onClick={() => setOpen((v) => !v)}
      >
        <span class="energy-dots" aria-hidden="true">
          {dots}
        </span>
        <span class="energy-label">{t('ui.energy.label', { n, max: ENERGY_MAX })}</span>
      </button>
      {open && (
        <p class="hint energy-why">
          {reasons.length === 0 ? t('ui.energy.full') : reasons.map((key) => t(key)).join(' · ')}
        </p>
      )}
    </div>
  );
}
